import React from "react";
import styled from "styled-components";
import { Menu } from "antd";
import "./Menu.scss";

const Wrapper = styled.div`
  background: #f4f4f4;
  border-bottom: 1px solid #e8e8e8;
`;

const MenuItem = Menu.Item;

class AppMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  handleClick(_e) {
    console.log("_e", _e);
  }

  render() {
    return (
      <Wrapper>
        <Menu
          className="menu-app"
          style={{
            background: "#f4f4f4",    
            margin: "0 auto",
            paddingRight: 20,
            paddingLeft: 20,
            borderBottom: "none"
          }}
          onClick={this.handleClick}
          mode="horizontal"
        >
          <MenuItem key="boxes">
            {/*<a href="/">Home</a>*/}
          </MenuItem>
        </Menu>
      </Wrapper>
    );
  }
}

export default AppMenu;
